import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDetalhesEmpenho = '/service/contabilidade/transparencia/detalhesEmpenho/'

class DetalhesEmpenhoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultarDetalhes(filtro) {
        let data = {
            administracao: filtro.administracao,
            anoMes: filtro.anoMes,
            recursoContabil: null,
            codigoDestinacao: null,
            orgaoContabil: null,
            unidadeContabil: null,
            codigoOrcamentario: null,
            identificacao: null,
            stnModelo: null,
            stnSequencia: null,
            numeroEmpenho: filtro.numeroEmpenho,
            codigoRubricaEmpenho: null,
        }
        return this.conex.post(urlDetalhesEmpenho + 'detalhes/', JSON.stringify(data))
    }

    consultarCredor(filtro) {
        let data = {
            administracao: filtro.administracao,
            anoMes: filtro.anoMes,
            recursoContabil: null,
            codigoDestinacao: null,
            orgaoContabil: null,
            unidadeContabil: null,
            codigoOrcamentario: null,
            identificacao: null,
            stnModelo: null,
            stnSequencia: null,
            numeroEmpenho: filtro.numeroEmpenho,
            codigoRubricaEmpenho: null,
        }
        return this.conex.post(urlDetalhesEmpenho + 'credor/', JSON.stringify(data))
    }

    consultarBaseLegal(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicio,
            numeroEmpenho: filtro.numeroEmpenho,
        }
        return this.conex.post(urlDetalhesEmpenho + 'baseLegal/', JSON.stringify(data))
    }

    consultarItens(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicioEmpenho,
            numeroEmpenho: filtro.numeroEmpenho,
        }
        return this.conex.post(urlDetalhesEmpenho + 'itens/', JSON.stringify(data))
    }

    consultarLiquidacoesComprovantes(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicioEmpenho,
            numeroEmpenho: filtro.numeroEmpenho,
        }
        return this.conex.post(urlDetalhesEmpenho + 'liquidacoesComprovantes/', JSON.stringify(data))
    }

    consultarOperacoes(filtro) {
        let data = {
            administracao: filtro.administracao,
            anoMes: filtro.anoMes,
            recursoContabil: null,
            codigoDestinacao: null,
            orgaoContabil: null,
            unidadeContabil: null,
            exercicioEmpenho: filtro.exercicioEmpenho,
            numeroEmpenho: filtro.numeroEmpenho,
        }
        return this.conex.post(urlDetalhesEmpenho + 'operacoes/', JSON.stringify(data))
    }

    consultarDetalhamentoOrcamentario(filtro) {
        let data = {
            administracao: filtro.administracao,
            anoMes: filtro.anoMes,
            recursoContabil: null,
            codigoDestinacao: null,
            orgaoContabil: null,
            unidadeContabil: null,
            codigoOrcamentario: null,
            identificacao: null,
            stnModelo: null,
            stnSequencia: null,
            numeroEmpenho: filtro.numeroEmpenho,
            codigoRubricaEmpenho: null,
        }
        return this.conex.post(urlDetalhesEmpenho + 'detalhamentoOrcamentario/', JSON.stringify(data))
    }

    consultarValoresEmpenho(filtro) {
        let data = {
            administracao: filtro.administracao,
            anoMes: filtro.anoMes,
            recursoContabil: null,
            codigoDestinacao: null,
            orgaoContabil: null,
            unidadeContabil: null,
            codigoOrcamentario: null,
            identificacao: null,
            stnModelo: null,
            stnSequencia: null,
            numeroEmpenho: filtro.numeroEmpenho,
            codigoRubricaEmpenho: null,
        }
        return this.conex.post(urlDetalhesEmpenho + 'valores/', JSON.stringify(data))
    }

    consultarRetencoes(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicioEmpenho,
            numeroEmpenho: filtro.numeroEmpenho,
        }
        return this.conex.post(urlDetalhesEmpenho + 'recuperarRetencoes/', JSON.stringify(data))
    }

    consultarPagamentos(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicioEmpenho,
            numeroEmpenho: filtro.numeroEmpenho,
        }
        return this.conex.post(urlDetalhesEmpenho + 'pagamentos/', JSON.stringify(data))
    }
}

export default DetalhesEmpenhoService
